import { combineReducers } from 'redux';

import { PhoneVerificationAction } from '../types';
import {
  verifyPhoneSuccess,
  verifyPhoneRequest,
  verifyPhoneFail,
  verifyPhoneClear,
  resetVerificationCodeCurrentAttempt,
} from '../actions';

const loading = (state = false, action: PhoneVerificationAction) => {
  switch (action.type) {
    case verifyPhoneRequest.type:
      return true;

    case verifyPhoneSuccess.type:
    case verifyPhoneFail.type:
      return false;

    default:
      return state;
  }
};

const verified = (state = false, action: PhoneVerificationAction) => {
  switch (action.type) {
    case verifyPhoneSuccess.type:
      return true;

    case verifyPhoneRequest.type:
    case verifyPhoneFail.type:
    case verifyPhoneClear.type:
      return false;

    default:
      return state;
  }
};

const currentAttempt = (state = 0, action: PhoneVerificationAction) => {
  switch (action.type) {
    case verifyPhoneFail.type:
      return state + 1;

    case resetVerificationCodeCurrentAttempt.type:
      return 0;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  verified,
  currentAttempt,
});
